<template>
<div class="header-caption-block relative">
    <video class="header-caption-overlay" autoplay loop muted webkit-playsinline playsinline>
        <source src="/video.mp4" type="video/mp4">
    </video>
    <div class="header-caption-container relative">
        <div class="header-caption-title">
            <h1>{{ $t('dashboard.hero.kickstart_journey') }}</h1>
            <h2>{{ $t('dashboard.hero.zero_fees_mocco') }}</h2>

            <Link v-if="!$page.props.user" :href="route('register')" class="header-caption-button">{{ $t('dashboard.hero.join_now') }}</Link>
            <Link v-else :href="route('markets')" class="header-caption-button">{{ $t('dashboard.actions.trade_now') }}</Link>
        </div>
    </div>
</div>

</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods: {

    }
}
</script>
